export const GET_PRE_REGISTERED_DOCUMENTS_REQUEST =
  'GET_PRE_REGISTERED_DOCUMENTS_REQUEST';
export const GET_PRE_REGISTERED_DOCUMENTS_SUCCESS =
  'GET_PRE_REGISTERED_DOCUMENTS_SUCCESS';
export const GET_PRE_REGISTERED_DOCUMENTS_ERROR =
  'GET_PRE_REGISTERED_DOCUMENTS_ERROR';

export const DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST =
  'DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST';
export const DELETE_PRE_REGISTERED_DOCUMENTS_SUCCESS =
  'DELETE_PRE_REGISTERED_DOCUMENTS_SUCCESS';
export const DELETE_PRE_REGISTERED_DOCUMENTS_ERROR =
  'DELETE_PRE_REGISTERED_DOCUMENTS_ERROR';
